var map = {
	"./back-2.png": "029d",
	"./back3.png": "973d",
	"./car-steering-wheel.svg": "e76a",
	"./default-avatar.png": "4294",
	"./driver-management.svg": "ebfd",
	"./local_shipping.svg": "0521",
	"./logo.png": "9d64",
	"./newBack.jpg": "8913",
	"./pattern.png": "1e4b",
	"./report.png": "0a82",
	"./title.png": "35cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";